import { Option } from "core/components/form/select";

export const currencySelectOptions: Option[] = [
    { label: "Australian Dollar (AUD)", value: "en-AU" },
    { label: "British Pound Sterling (GBP)", value: "en-GB" },
    { label: "New Zealand Dollar (NZD)", value: "en-NZ" },
    { label: "American Dollar (USD)", value: "en-US" },
];
